import { HidCredentialRedemptionRequestProviderParams } from '~generated-api/models/hid-credential-redemption-request-provider-params';

export class HidCredentialRedemptionRequestProviderParamsModel implements HidCredentialRedemptionRequestProviderParams {
  readonly credentialProvider: string = 'HID';
  readonly googleAud: string;
  readonly googleNonce: string;
  readonly googleUser: string;

  constructor(init: Omit<HidCredentialRedemptionRequestProviderParams, 'credentialProvider'>) {
    this.googleAud = init.googleAud;
    this.googleNonce = init.googleNonce;
    this.googleUser = init.googleUser;
  }
}
